export default __webpack_public_path__ + "static/media/howTOTrackOrderStatus.3da66fac.png";